export interface UsageProgressBarProps {
  usedMinutes: number;
  includedMinutes: number;
}

const SAFE_GREEN = '#16A34A';
const CAUTION_AMBER = '#D97706';
const OVERAGE_RED = '#DC2626';

function pickColor(pct: number): string {
  if (pct >= 100) return OVERAGE_RED;
  if (pct >= 75) return CAUTION_AMBER;
  return SAFE_GREEN;
}

export function UsageProgressBar({
  usedMinutes,
  includedMinutes,
}: UsageProgressBarProps): JSX.Element {
  const pct = includedMinutes > 0 ? (usedMinutes / includedMinutes) * 100 : 100;
  const color = pickColor(pct);
  const width = Math.min(pct, 100);
  return (
    <div
      role="progressbar"
      aria-valuenow={usedMinutes}
      aria-valuemin={0}
      aria-valuemax={includedMinutes}
      aria-label="Cycle usage"
      style={{
        position: 'relative',
        height: 12,
        backgroundColor: '#F1F1F3',
        borderRadius: 9999,
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          width: `${width}%`,
          height: '100%',
          backgroundColor: color,
          borderRadius: 9999,
          transition: 'width 400ms ease-out',
        }}
      />
    </div>
  );
}
